export enum DefaultFields {
  Email = 'Email',
  firstName = 'First Name',
  lastName = 'Last Name',
}
